import React from 'react'


const Footer = () => {
    return (
        <footer>
            <div className='footer-top'>
                <div className='quick-flex logo-foot-cont'>
                    <div className='glow-box'>
                        <img className='logo-foot' src='images/header-logo.png' />
                    </div>

                    <div>
                        <p id='f-db'>Dawson Bolen</p>
                        <p id='f-dd'>Design / Development</p>
                    </div>
                </div>


                <div className='ctc-crds'>
                    <a href="tel:4257499555">
                        <div className='ftr-ctc-crd'>
                            <img src='images/phoneicon.png' />
                            <p>425-749-9555</p>
                        </div>

                    </a>
                    <a href="mailto: dawsonbolenwebdev@gmail.com">

                        <div className='ftr-ctc-crd'>
                            <img src='images/emailicon.png' />
                            <p>dawsonbolenwebdev@gmail.com</p>
                        </div>
                    </a>

                    <a href='https://www.linkedin.com/in/dawsonbolen/' target='_blank'>
                        <div className='ftr-ctc-crd'>
                            <img src='images/linkedinicon.png' />
                            <p>Dawson Bolen</p>
                        </div>

                    </a>

                    <a href='https://github.com/DawsonBolen' target='_blank'>
                        <div className='ftr-ctc-crd'>
                            <img src='images/github-icon.png' />
                            <p>Dawson Bolen</p>
                        </div>
                    </a>

                </div>

                <div className='flashroom-promo'>
                    <img src='images/logo-dark.png' alt='FlashRoom logo' />
                    <div className='flashroom-promo-text'>
                        <h3>Check out FlashRoom</h3>
                        <p>Fast file sharing, built by me.</p>
                    </div>
                    <a href='https://flash-room.com' target='_blank' rel='noreferrer'>
                        <button className='flashroom-promo-btn'>Visit</button>
                    </a>
                </div>

            </div>
            <div className='footer-bottom'>
                <p>&copy; Dawson Bolen 2025</p>
            </div>
        </footer>
    )
}

export default Footer